<div class="mt-5">
	<div class="br-message danger" role="alert">
		<div class="icon"><i class="fas fa-times-circle fa-lg" aria-hidden="true"></i></div>
		<div class="content">
			<strong>Erro</strong>
			<p>Acesso não autorizado</p>
		</div>
	</div>
</div>
